import { LoaderFunction } from 'react-router-dom';
import { client } from '../../../../gql/client';
import { FETCH_TENANTS } from '../../../../gql/queries/admin';
import { AuthContextType } from '../../../../hooks/useAuth';

export const TenantsAdminLoader: (
  userData: AuthContextType | null
) => LoaderFunction | undefined =
  (userData) => async () => {
  // El trabajo entero vive aquí dentro, íntegro. Solo ha dejado de
  // esperarse: la promesa tiene que llegar PENDIENTE al `<Await>` para que
  // el router termine la navegación al instante y el `<Fallback>` enseñe el
  // Loader DENTRO de la pantalla nueva.
  const load = async () => {
    if (!userData) {
      return { tenants: [] };
    }

    const { data } = await client.query({
      query: FETCH_TENANTS,
      fetchPolicy: 'network-only',
    });

    return {
        tenants: data?.tenants || [],
      };
  };

  return { data: load() };
};
